import { render, staticRenderFns } from "./SidebarCreateDocument.vue?vue&type=template&id=c4dbc7a0&scoped=true&"
import script from "./SidebarCreateDocument.vue?vue&type=script&lang=ts&"
export * from "./SidebarCreateDocument.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarCreateDocument.vue?vue&type=style&index=0&id=c4dbc7a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4dbc7a0",
  null
  
)

export default component.exports